import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { isEmpty } from 'lodash';
import { Download, Maximize } from 'react-feather';
import ReactLoading from 'react-loading';

import FileIcon from '../FileIcon';
import * as AttachmentUtils from '../../helpers/AttachmentUtils';
import UpdoxVideoPlayer from '../UpdoxVideoPlayer';
import AttachmentPreview from '../AttachmentPreview';

class Attachment extends Component {
  constructor(props) {
    super(props);

    const { attachment } = this.props;

    this.state = {
      isBufferingVideo: false,
      downloading: false,
      downloaded: false,
      isVideoPlayClicked: AttachmentUtils.isVideo(attachment) && !isEmpty(attachment.downloadUrl),
    };
  }

  /**
   * Non images are not immediately downloaded and therefore a url is not present for them.
   * When a user clicks download, it dispatches an async action to download the file
   * When the file is downloaded we build the url and then we can trigger the download
   */
  componentDidUpdate = (prevProps) => {
    const { isBufferingVideo, downloaded, isVideoPlayClicked } = this.state;
    const { downloadUrl, id } = this.props.attachment;
    const isNotImage = !AttachmentUtils.isImage(this.props.attachment);

    // Images will downloaded right away, everything else will need to wait for
    // the attachment to be loaded from the server.
    if (isNotImage && !prevProps.attachment.downloadUrl && downloadUrl) {
      if (isBufferingVideo) {
        this.setState({ isBufferingVideo: false });
      } else {
        const downloadElement = document.getElementById(`attachment-${id}`);
        downloadElement.click();
        this.setState({ downloading: false });
      }
    }

    // Ensure the attachment.downloadUrl is revoked once an item has been downloaded successfully. Images,
    // should always retain their download & display URLs because it's the same content, but for everything
    // else ensure the attachment needs to be re-fetched.
    if (!isVideoPlayClicked && isNotImage && downloaded) {
      this.props.revokeAttachmentUrl(id);
      this.setState({ downloaded: false });
    }
  };

  /**
   * If the url is built, return true to continue the download action,
   * otherwise, dispatch the download attachment action so that the
   * download does not kick off until the attachment is returned from the
   * server.
   */
  getUrl = () => {
    const { id, downloadUrl } = this.props.attachment;
    if (downloadUrl) {
      this.setState({ downloaded: true });
      return true;
    } else {
      this.setState({ downloading: true, downloaded: false });
      this.props.downloadAttachment(id);
      return false;
    }
  };

  getAnchorClassNames = () => {
    if (this.state.downloading) return 'disable-link';
  };

  /*
   * When the message contains an image as an attachment, we want to dynamically render it to the screen.
   * Next step is to incorporate a progressive image loading scheme.
   */
  displayAttachment = () => {
    const { downloading } = this.state;
    const attachment = this.props.attachment;
    const { id, downloadUrl, displayUrl, fileName, mediaType, isDownloading } = attachment;
    const isImage = AttachmentUtils.isImage(attachment);
    const isVideo = AttachmentUtils.isVideo(attachment);

    return (
      <div className="attachment" key={id} data-qa="messageAttachment">
        <div className="attachment-meta flex flex-center-x">
          <span className="attachment-type-icon">
            <FileIcon type={mediaType} size={20}/>
          </span>
          <span className="attachment-filename">{fileName}</span>
          <a
            className={this.getAnchorClassNames()}
            id={`attachment-${id}`}
            onClick={this.getUrl}
            href={downloadUrl}
            download={fileName}
          >
            {downloading
              ? <ReactLoading type="spin" color="#fff" height={16} width={16}/>
              : <Download size={16}/>
            }
          </a>
        </div>
        {isImage &&
          <div className="media-container flex flex-center">
            {displayUrl &&
              <AttachmentPreview
                imageSrc={displayUrl}
                imageAlt={fileName}
                overlayIconComponent={<Maximize size={48}/>}
                overlayText="View Full Screen"
                onClick={this.onViewImage}
              />
            }
          </div>
        }
        {isVideo &&
          AttachmentUtils.isSupportedVideoStreamType(mediaType) &&
            <div className="media-container">
              <UpdoxVideoPlayer
                sourceUrl={downloadUrl}
                previewUrl={displayUrl}
                width="100%"
                height={225}
                isDownloading={isDownloading}
                onPlayClicked={this.playVideo}
              />
            </div>
        }
      </div>
    );
  };

  onViewImage = () => {
    const { attachment, history } = this.props;
    history.push({
      pathname: `/attachment/${attachment.id}`,
      state: {
        modal: true,
      },
    });
  };

  playVideo = () => {
    const { downloadAttachment, attachment, downloadUrl } = this.props;

    this.setState({ isBufferingVideo: true, isVideoPlayClicked: true });

    if (isEmpty(downloadUrl)) {
      downloadAttachment(attachment.id, true);
    }
  };

  render() {
    return (
      <div className="attachment">
        {this.displayAttachment()}
      </div>
    );
  }
}

export default withRouter(Attachment);
